/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AssetInfo } from './AssetInfo';
import {
    AssetInfoFromJSON,
    AssetInfoFromJSONTyped,
    AssetInfoToJSON,
} from './AssetInfo';

/**
 * 
 * @export
 * @interface EnrichedOptimizerTrade
 */
export interface EnrichedOptimizerTrade {
    /**
     * 
     * @type {string}
     * @memberof EnrichedOptimizerTrade
     */
    tradeId: string;
    /**
     * 
     * @type {number}
     * @memberof EnrichedOptimizerTrade
     */
    optimizationId: number;
    /**
     * 
     * @type {string}
     * @memberof EnrichedOptimizerTrade
     */
    pId: string;
    /**
     * 
     * @type {string}
     * @memberof EnrichedOptimizerTrade
     */
    sId: string;
    /**
     * 
     * @type {string}
     * @memberof EnrichedOptimizerTrade
     */
    allocationType: string;
    /**
     * 
     * @type {number}
     * @memberof EnrichedOptimizerTrade
     */
    tradeQuantity: number;
    /**
     * 
     * @type {number}
     * @memberof EnrichedOptimizerTrade
     */
    orderPrice: number;
    /**
     * 
     * @type {string}
     * @memberof EnrichedOptimizerTrade
     */
    priceSource?: string;
    /**
     * 
     * @type {string}
     * @memberof EnrichedOptimizerTrade
     */
    priceTimestamp?: string;
    /**
     * 
     * @type {string}
     * @memberof EnrichedOptimizerTrade
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof EnrichedOptimizerTrade
     */
    portfolioGuid?: string;
    /**
     * 
     * @type {string}
     * @memberof EnrichedOptimizerTrade
     */
    brokerId?: string;
    /**
     * 
     * @type {string}
     * @memberof EnrichedOptimizerTrade
     */
    aC?: string;
    /**
     * 
     * @type {number}
     * @memberof EnrichedOptimizerTrade
     */
    nav?: number;
    /**
     * 
     * @type {number}
     * @memberof EnrichedOptimizerTrade
     */
    cash?: number;
    /**
     * 
     * @type {string}
     * @memberof EnrichedOptimizerTrade
     */
    tradeDate?: string;
    /**
     * 
     * @type {AssetInfo}
     * @memberof EnrichedOptimizerTrade
     */
    asset?: AssetInfo;
    /**
     * 
     * @type {number}
     * @memberof EnrichedOptimizerTrade
     */
    tradeValue?: number;
}

/**
 * Check if a given object implements the EnrichedOptimizerTrade interface.
 */
export function instanceOfEnrichedOptimizerTrade(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "tradeId" in value;
    isInstance = isInstance && "optimizationId" in value;
    isInstance = isInstance && "pId" in value;
    isInstance = isInstance && "sId" in value;
    isInstance = isInstance && "allocationType" in value;
    isInstance = isInstance && "tradeQuantity" in value;
    isInstance = isInstance && "orderPrice" in value;
    isInstance = isInstance && "createdAt" in value;

    return isInstance;
}

export function EnrichedOptimizerTradeFromJSON(json: any): EnrichedOptimizerTrade {
    return EnrichedOptimizerTradeFromJSONTyped(json, false);
}

export function EnrichedOptimizerTradeFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnrichedOptimizerTrade {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tradeId': json['trade_id'],
        'optimizationId': json['optimization_id'],
        'pId': json['p_id'],
        'sId': json['s_id'],
        'allocationType': json['allocation_type'],
        'tradeQuantity': json['trade_quantity'],
        'orderPrice': json['order_price'],
        'priceSource': !exists(json, 'price_source') ? undefined : json['price_source'],
        'priceTimestamp': !exists(json, 'price_timestamp') ? undefined : json['price_timestamp'],
        'createdAt': json['created_at'],
        'portfolioGuid': !exists(json, 'portfolio_guid') ? undefined : json['portfolio_guid'],
        'brokerId': !exists(json, 'broker_id') ? undefined : json['broker_id'],
        'aC': !exists(json, 'a_c') ? undefined : json['a_c'],
        'nav': !exists(json, 'nav') ? undefined : json['nav'],
        'cash': !exists(json, 'cash') ? undefined : json['cash'],
        'tradeDate': !exists(json, 'trade_date') ? undefined : json['trade_date'],
        'asset': !exists(json, 'asset') ? undefined : AssetInfoFromJSON(json['asset']),
        'tradeValue': !exists(json, 'trade_value') ? undefined : json['trade_value'],
    };
}

export function EnrichedOptimizerTradeToJSON(value?: EnrichedOptimizerTrade | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'trade_id': value.tradeId,
        'optimization_id': value.optimizationId,
        'p_id': value.pId,
        's_id': value.sId,
        'allocation_type': value.allocationType,
        'trade_quantity': value.tradeQuantity,
        'order_price': value.orderPrice,
        'price_source': value.priceSource,
        'price_timestamp': value.priceTimestamp,
        'created_at': value.createdAt,
        'portfolio_guid': value.portfolioGuid,
        'broker_id': value.brokerId,
        'a_c': value.aC,
        'nav': value.nav,
        'cash': value.cash,
        'trade_date': value.tradeDate,
        'asset': AssetInfoToJSON(value.asset),
        'trade_value': value.tradeValue,
    };
}

